/**
 * Marketing landing page — what people see at https://lighthouseapp.net
 * and https://www.lighthouseapp.net. The dashboard lives at
 * https://app.lighthouseapp.net (separate hostname check in main.tsx).
 */
export function Landing() {
  return (
    <div style={{ maxWidth: 920, margin: "0 auto", padding: "60px 24px 100px" }}>
      <div style={{ textAlign: "center", marginBottom: 60 }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "5px 13px",
            borderRadius: 999,
            border: "1px solid var(--border)",
            color: "var(--text-1)",
            fontSize: 12,
            marginBottom: 24,
          }}
        >
          <span className="dot ok live" /> Live status from your smart estate
        </div>
        <h1
          style={{
            fontSize: 52,
            lineHeight: 1.05,
            letterSpacing: "-0.02em",
            margin: 0,
            fontWeight: 600,
          }}
        >
          Know what's working in your home.
          <br />
          <span style={{ color: "var(--beacon)" }}>Before you do.</span>
        </h1>
        <p
          style={{
            fontSize: 17,
            color: "var(--text-1)",
            marginTop: 22,
            maxWidth: 600,
            marginLeft: "auto",
            marginRight: "auto",
            lineHeight: 1.5,
          }}
        >
          Lighthouse continuously checks the internet, routers, KNX bus, Gira
          servers, lights, cameras and AV in your residential or commercial
          smart estate. When something stops responding, you hear about it
          first — by email, then push.
        </p>

        <div style={{ marginTop: 36, display: "flex", justifyContent: "center", gap: 14, flexWrap: "wrap" }}>
          <a
            href="https://app.lighthouseapp.net"
            style={{
              background: "var(--beacon)",
              color: "var(--bg-0)",
              padding: "14px 28px",
              borderRadius: 999,
              fontWeight: 600,
              letterSpacing: "0.04em",
              fontSize: 14,
              textDecoration: "none",
            }}
          >
            Sign in / sign up
          </a>
          <a
            href="https://app.lighthouseapp.net"
            style={{
              padding: "14px 28px",
              borderRadius: 999,
              border: "1px solid var(--border)",
              color: "var(--text-0)",
              fontWeight: 500,
              fontSize: 14,
            }}
          >
            Open the dashboard →
          </a>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: 18,
          marginTop: 50,
        }}
      >
        <Feature
          title="Always-on heartbeat"
          body="A small box on site pings every device every 30 seconds and reports back. No more &lsquo;works for me&rsquo;."
        />
        <Feature
          title="Per-apartment views"
          body="In a multi-unit building each apartment sees only its own infrastructure. The integrator sees everything."
        />
        <Feature
          title="Alerts that pre-empt the call"
          body="When a service goes from operational to offline, you get the email seconds later. The estate manager messages the integrator first."
        />
      </div>

      <p style={{ marginTop: 80, textAlign: "center", color: "var(--text-2)", fontSize: 12 }}>
        © Thinking Fish Ltd · Lighthouse is in private beta
      </p>
    </div>
  );
}

function Feature({ title, body }: { title: string; body: string }) {
  return (
    <div
      style={{
        background: "var(--bg-1)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius)",
        padding: "20px 22px",
        boxShadow: "var(--shadow)",
      }}
    >
      <div style={{ fontFamily: "var(--font-display)", fontWeight: 600, fontSize: 16, marginBottom: 8 }}>
        {title}
      </div>
      <div style={{ color: "var(--text-1)", fontSize: 13.5, lineHeight: 1.55 }}>{body}</div>
    </div>
  );
}
